'use client'
import dynamic from 'next/dynamic'

import { Loading } from '../../../loading'

export const DynamicProductVoucherDialogContent = dynamic(
  async () =>
    import('./ProductVoucherDialogContent').then(
      (mod) => mod.ProductVoucherDialogContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)
